import React, { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Input } from '@components/form/input';
import { Checkbox } from '@components/form/checkbox';

export const DisabledPerson = observer(
  ({ register, formState, control, setValue, postulant = {}, unregister, handicapped }) => {
    const [t] = useTranslation();
    const { discapacidad = { status: false } } = postulant;
    const [inputDisabled, setInputDisabled] = useState(true);
    const ref = useRef('discapacidad.status');

    useEffect(() => {
      if (postulant.discapacidad) {
        setValue('discapacidad.status', discapacidad.status);
        setValue('discapacidad.detalle', discapacidad.detalle);
        setInputDisabled(!discapacidad.status);
      }
      return () => {
        return discapacidad === false;
      };
    }, [discapacidad]);

    return (
      <>
        <Checkbox
          label={t('postulant.disabled_person.checkbox_text')}
          name='discapacidad.status'
          refCustom={ref}
          control={control}
          defaultChecked={discapacidad.status || false}
          onChange={() => {
            setInputDisabled((prev) => !prev);
            setValue('discapacidad.detalle', '');
            unregister('discapacidad.detalle', { keepError: true });
          }}
        />
        <Input
          title={t('postulant.disabled_person.input_title')}
          placeholder='Ingresa una descripción'
          name='discapacidad.detalle'
          type='text'
          register={register}
          formState={formState}
          validate={{
            required: inputDisabled === false && handicapped === 1,
            minLength: 1,
            whiteSpace: true
          }}
          errorPosition='bottom'
          disabled={inputDisabled}
        />
      </>
    );
  }
);
